import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';

const AnimatedSidebarIcon = () => {
  return (
    <Tooltip title="Click for more details">
      <Box
        sx={{
          display: 'inline-flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 0.25,
          cursor: 'pointer',
          color: '#7FB3E0',
          padding: '4px 8px',
          borderRadius: '4px',
          transition: 'color 0.2s ease',
          backgroundColor: 'transparent !important',
          '&:hover': {
            color: '#1976d2',
            backgroundColor: 'transparent !important',
          },
        }}
      >
        <ContentPasteSearchIcon sx={{ fontSize: '1.75rem' }} />
        <Typography
          variant='caption'
          sx={{
            fontSize: '0.7rem',
            fontWeight: 500,
            lineHeight: 1,
            textAlign: 'center',
            color: 'inherit',
          }}
        >
          View<br />Details
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default AnimatedSidebarIcon;
